var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFantom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 128",
    style: {
      enableBackground: "new 0 0 101 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,1.2c3.1-1.6,7.8-1.6,11,0l31.7,16.7c1.9,1,2.9,2.5,3.1,4h0v83.9c0,1.7-1.1,3.3-3.1,4.4l-31.7,16.7 c-3.1,1.6-7.8,1.6-11,0l-31.7-16.7c-2-1.1-3-2.7-3.1-4.4c0-0.2,0-0.3,0-0.4l0-82.9c0-0.1,0-0.2,0-0.3l0-0.3l0,0c0.1-1.5,1.1-3,3-4 L45,1.2z M85.8,68.7L55.9,84.4c-3.1,1.6-7.8,1.6-11,0L15.2,68.7v36.9L45,121.1c1.7,0.9,3.4,1.8,5.1,1.9l0.3,0c1.8,0,3.5-0.9,5.3-1.7 l30.1-15.9V68.7z M5,103.9c0,3.2,0.4,5.3,1.1,6.8c0.6,1.2,1.5,2.2,3.2,3.3l0.1,0.1c0.4,0.2,0.8,0.5,1.3,0.8l0.6,0.4l1.8,1.1 l-2.6,4.3l-2-1.2l-0.3-0.2c-0.6-0.4-1.1-0.7-1.5-1C1.8,115,0,111.5,0,104.1l0-0.2H5z M47.9,46.2c-0.2,0.1-0.4,0.2-0.6,0.3L15.5,63.1 c0,0-0.1,0-0.1,0.1l0,0l0,0l0.1,0L47.3,80c0.2,0.1,0.4,0.2,0.6,0.3V46.2z M52.9,46.2v34c0.2-0.1,0.4-0.2,0.6-0.3l31.7-16.7 c0,0,0.1,0,0.1-0.1l0,0l0,0l-0.1,0L53.6,46.5C53.4,46.4,53.2,46.3,52.9,46.2z M85.8,27.8l-28.5,15l28.5,15V27.8z M15.2,27.9v29.9 l28.4-14.9L15.2,27.9z M53.6,5.6c-1.7-0.9-4.6-0.9-6.3,0L15.5,22.3c0,0-0.1,0-0.1,0.1l0,0l0,0l0.1,0l31.7,16.7 c1.7,0.9,4.6,0.9,6.3,0l31.7-16.7c0,0,0.1,0,0.1-0.1l0,0l0,0l-0.1,0L53.6,5.6z M90.5,7.5l2,1.2l0.3,0.2c0.6,0.4,1.1,0.7,1.5,1 c4.8,3.2,6.6,6.8,6.7,14.1l0,0.2h-5c0-3.2-0.4-5.3-1.1-6.8c-0.6-1.2-1.5-2.2-3.2-3.3L91.6,14c-0.4-0.2-0.8-0.5-1.3-0.8l-0.6-0.4 l-1.8-1.1L90.5,7.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantom);
export default __webpack_public_path__ + "static/media/fantom.c34fc3aa1f94e46552b2adb0b89e6955.svg";
export { ForwardRef as ReactComponent };